@if ((isAuthenticated$ | async) === true) {
  <div class="w-full h-full flex flex-col">
    <lib-clinician-app-bar (logout)="logout()" />
    <router-outlet />
  </div>
} @else {
  <div class="w-full h-full flex flex-col items-center justify-center gap-8">
    <img
      class="w-[384px]"
      ngSrc="/images/shareview-logo.png"
      alt="ShareView logo"
      width="1536"
      height="435"
      priority
    />
    <button matButton="filled" (click)="login()">Sign In to ShareView</button>
  </div>
}
